import { render, staticRenderFns } from "./SelectTagModal.vue?vue&type=template&id=37b0b734&"
import script from "./SelectTagModal.vue?vue&type=script&lang=js&"
export * from "./SelectTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b0b734')) {
      api.createRecord('37b0b734', component.options)
    } else {
      api.reload('37b0b734', component.options)
    }
    module.hot.accept("./SelectTagModal.vue?vue&type=template&id=37b0b734&", function () {
      api.rerender('37b0b734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/tags/SelectTagModal.vue"
export default component.exports